<template>
<div class="loaderic">
  <div class="loader">
    <div class="loader__ext" :style="bcExt"></div>
    <div class="loader__int" :style="bcInt"></div>
  </div>
</div>
</template>

<script>
import { Stream } from 'stream';
export default {
  props: {
    spinExt: {
      type: String,
      default: '#000000'
    },
    spinInt: {
      type: String,
      default: '#000000'
    }
  },
  data() {
    return {
      bcExt: {
        borderColor: this.spinExt
      },
      bcInt: {
        borderColor: this.spinInt
      }
    }
  }
}
</script>

<style lang="scss" scoped>
//3-TOOLS
@keyframes spin-ext{
  0% {
    transform: rotate(0deg)
  }
  100% {
    transform: rotate(360deg)
  }
}

@keyframes spin-int{
  0% {
    transform: rotate(0deg)
  }
  100% {
    transform: rotate(-360deg)
  }
}
//4-GENERIC
*,
*::before,
*::after{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.loaderic{
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader{
  width: 25px;
  height: 25px;
  position: relative;

  &__ext{
    height: 100%;
    width: 100%;
    border-style: solid;
    border-width: 1px;
    border-bottom: 0;
    border-left-color: transparent !important;
    border-radius: 100%;

    animation-name: spin-ext;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: cubic-bezier(.42,.61,.58,.41);
  }

  &__int{
    height: 66%;
    width: 66%;
    position: absolute;
    left: calc(50% - 33%);
    top: calc(50% - 33%);
    border-style: solid;
    border-width: 1px;
    border-right: 0;
    border-top-color: transparent !important;
    border-radius: 100%;

    animation-name: spin-int;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: cubic-bezier(.42,.61,.58,.41);
  }

}

</style>
